(() => {
  function setup(root) {
    root.querySelectorAll('[data-linnen-form]').forEach((wrapper) => {
      if (wrapper.dataset.ready) return;
      wrapper.dataset.ready = 'true';
      const product = wrapper.querySelector('[data-product]');
      if (!product) return;
      const amount = wrapper.querySelector('[data-amount]');
      const amountField = wrapper.querySelector('[data-amount-field]');
      const volume = wrapper.querySelector('[data-volume]');
      const volumeField = wrapper.querySelector('[data-volume-field]');
      const washing = wrapper.querySelector('[data-washing]');
      const params = new URLSearchParams(window.location.search);
      const sku = params.get('artikel');
      const matching = Array.from(product.options).find((option) => sku && option.value.startsWith(sku + ' —'));
      if (matching) product.value = matching.value;
      if (params.get('dienst') === 'wasservice') {
        product.value = 'Alleen wasservice';
        washing.value = 'Ja';
      }
      function update() {
        const onlyWashing = product.value === 'Alleen wasservice';
        const hasWashing = onlyWashing || washing.value !== 'Nee';
        amount.required = !onlyWashing;
        amount.disabled = onlyWashing;
        amountField.hidden = onlyWashing;
        volume.disabled = !hasWashing;
        volumeField.hidden = !hasWashing;
        if (onlyWashing) washing.value = 'Ja';
      }
      product.addEventListener('change', update);
      washing.addEventListener('change', update);
      update();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
